import { useEffect } from "react";
import "./winners.scss";
import SocialMediaBox from "../../components/SocialMediaBox/SocialMediaBox";
import WinnerTable from "../../components/WinnerTable/WinnerTable";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import {
  winnerBanner,
  winnerBannerMb,
  winnerLeftElement,
  winnerRightElement,
} from "../../source";
import HashScroll from "../../components/HashScroll/HashScroll";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";

const Winners = () => {
  const { width } = useWindowDimensions();

  const scrollToSection = (scrollid, offset) => {
    const id = scrollid;
    const yOffset = offset;
    const element = document.getElementById(id);
    const y =
      element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <MetaDecorator
        canonicalLink={window.location.href}
        metaTitle="Everest Taste Masters Winners | The Ultimate Taste Champions"
        metaDesc="Explore the Everest Taste Masters winner announcement and discover the foodie who earned the title of Taste Master."
      />
      <section className="winner_sec1">
        <div className="banner_container">
          <img
            src={width > 600 ? winnerBanner : winnerBannerMb}
            alt="winners"
            width={width > 600 ? 1920 : 375}
            height={width > 600 ? 930 : 800}
            loading="eager"
            className="banner_img"
            onClick={() => scrollToSection("winner_sec2", -60)}
          />
        </div>
      </section>

      <section className="winner_sec2" id="winner_sec2">
        <img
          src={winnerRightElement}
          alt="chilly"
          width={246}
          height={388}
          className="right_element"
        />
        {/* <div className="my_container"> */}
          <WinnerTable />
        {/* </div> */}
      </section>

      <section className="winner_sec3">
        <SocialMediaBox
          title="Pssst … We know you know other Foodies!"
          desc="Bring them onboard and double the flavour with exclusive perks
                          & amazing rewards"
          instaLink="https://www.instagram.com/everest_tastemasters/"
        />
      </section>

      <section className="winner_sec4">
        <img
          src={winnerLeftElement}
          alt="chilly"
          width={347}
          height={330}
          className="left_element"
        />
        <div className="my_container">
          <div className="text_container">
            <p className="desc">
              Let’s celebrate your creativity & love for food with rewards to
              match your passion
            </p>
            <h6 className="title">Happy cookin’ with Everest Taste Masters!</h6>
          </div>
        </div>
      </section>
      <HashScroll />
    </>
  );
};

export default Winners;
